import { modifyCustomerHomeAddCountJobs } from "./modifyCustomerHomeAddCountJobs";

export const MIGRATIONS_DEBUG = true;
export const migrations = {
  0: (state) => state,
  1: modifyCustomerHomeAddCountJobs,
}